export default {"src":"/_next/static/media/baseball.71297006.svg","height":55,"width":55,"blurWidth":0,"blurHeight":0};